import React, { useEffect, useRef, useState } from "react";

interface Props {
  props: {
    value: string;
    selectedRecordID: string;
    onEdit: (data: { value: string }) => void;
  };
}

export default function DescriptionForTas(props: Props) {
  const {
    props: { value = "", onEdit = () => {}, selectedRecordID },
  } = props;
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }, [value, selectedRecordID]);

  const valueChanged = useRef(false);

  const onBlur = (ev: any) => {
    if (valueChanged.current) {
      const val = ev.target.value;
      onEdit({ value: val });
      valueChanged.current = false;
    }
  };
  const onChange = (ev: any) => {
    const val = ev.target.value;
    if (val !== inputValue) {
      valueChanged.current = true;
      setInputValue(val);
    }
  };

  const onEnter = (ev: any) => {
    if (ev.shiftKey) {
      return;
    }
    ev.preventDefault();
    onBlur(ev);
  };

  const onKeyS = (ev: any) => {
    if (ev.ctrlKey) {
      ev.preventDefault();
      onBlur(ev);
    }
  };

  const onEscape = () => {
    valueChanged.current = false;
    setInputValue(value);
  };

  const onKeyDown = (ev: any) => {
    const keys: { [key: string]: (ev?: any) => void } = {
      Enter: onEnter,
      NumpadEnter: onEnter,
      KeyS: onKeyS,
      Escape: onEscape,
    };

    keys[ev.code]?.(ev);
  };

  return (
    <div id={"item_Text"} style={{ height: "100%", width: "100%", display: "flex" }}>
      <textarea
        onChange={onChange}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        value={inputValue}
        style={{
          display: "flex",
          flex: "1 1 0",
          width: "100%",
          outline: "0",
          resize: "none",
        }}
      />
    </div>
  );
}
